// extracted by mini-css-extract-plugin
module.exports = {"container":"Write_container__29jWb","itemA":"Write_itemA__D8TpH","itemB":"Write_itemB__3xWgg","itemC":"Write_itemC__X1oyh","itemD":"Write_itemD__lUwss"};